import React from "react";
import { Box, Chip } from "@mui/material";
import LandingSegmentToolbar from "../landingStudio/LandingSegmentToolbar";
import { useLandingSegmentContext } from "../landingStudio/LandingSegmentContext";
import { segmentCssVariables } from "../landingStudio/segmentVisualStyle";

export default function SectionFrame({
  id,
  label,
  active,
  hidden = false,
  enabled,
  onSelect,
  onToggle,
  children,
  sx,
}) {
  const isHidden = enabled === false || hidden;
  const { form, onOpenTool } = useLandingSegmentContext();
  const cssVariables = segmentCssVariables(form?.theme, id);

  return (
    <Box
      data-landing-section={id}
      onClick={() => onSelect(id)}
      sx={{
        position: "relative",
        opacity: isHidden ? 0.58 : 1,
        outline: active ? "2px solid rgba(243,90,58,.78)" : "1px solid transparent",
        outlineOffset: active ? -2 : 0,
        boxShadow: active ? "inset 0 0 0 1px rgba(243,90,58,.10)" : "none",
        transition: "outline .15s ease, box-shadow .15s ease, opacity .15s ease",
        ...cssVariables,
        "&:hover .landing-section-name": {
          opacity: 1,
          transform: "translateY(0)",
        },
        ...sx,
      }}
    >
      {active && onOpenTool ? (
        <LandingSegmentToolbar
          sectionId={id}
          label={label}
          enabled={!isHidden}
          canToggle={typeof onToggle === "function"}
          onToggle={onToggle}
          onOpenTool={onOpenTool}
        />
      ) : (
        <Chip
          className="landing-section-name"
          size="small"
          label={isHidden ? `${label} · oculta` : label}
          sx={{
            position: "absolute",
            top: 10,
            right: 10,
            zIndex: 35,
            opacity: isHidden ? 1 : 0,
            transform: isHidden ? "translateY(0)" : "translateY(-4px)",
            pointerEvents: "none",
            transition: "opacity .16s ease, transform .16s ease",
            bgcolor: "rgba(255,255,255,.95)",
            color: "#19242F",
            fontWeight: 900,
            boxShadow: "0 5px 18px rgba(25,36,47,.12)",
          }}
        />
      )}

      {isHidden ? (
        <Box
          aria-hidden
          sx={{
            position: "absolute",
            inset: 0,
            zIndex: 20,
            pointerEvents: "none",
            backgroundImage:
              "repeating-linear-gradient(-45deg, rgba(25,36,47,.015), rgba(25,36,47,.015) 10px, rgba(25,36,47,.045) 10px, rgba(25,36,47,.045) 20px)",
          }}
        />
      ) : null}
      {children}
    </Box>
  );
}
